import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getStaffGradesQuery,
  getUnitPlanFeedQuery,
  getOrganizationSubjectsQuery,
  getOrganizationStaffQuery,
  getStaffCoursesQuery,
} from "./Queries";

export const getStaffGradesQueryFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStaffGradesQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getUnitPlanFeedQueryFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getUnitPlanFeedQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getOrganizationSubjectsQueryFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationSubjectsQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getOrganizationStaffQueryFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationStaffQuery,
      variables,
    });
    return _.get(queryData, "node", []);
  } catch (e) {
    return {};
  }
};

export const getStaffCoursesFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStaffCoursesQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};
